import { create } from 'zustand';

interface InviteUserModalStore {
  open?: boolean;
  openModal: (params: { open?: boolean }) => void;
  close: () => void;
}

const useInviteUserModalStore = create<InviteUserModalStore>((set) => ({
  openModal: (params) => {
    set({ ...params });
  },
  close: () => set({ open: false }),
}));

export default useInviteUserModalStore;
